import React from 'react';
import { Box } from '@mui/material';
import type { NavigationItem } from '../navigationItems';
import { SidebarHeader } from './SidebarHeader';
import { SidebarContent } from './SidebarContent';
import { SIDEBAR_WIDTH } from './constants';
import { DARK_SHELL_SURFACE, LIGHT_SHELL_SURFACE } from '@billda/shared-ui';

interface DesktopSidebarProps {
  onToggleCollapse: () => void;
  permissions: string[];
  isActive: (path: string) => boolean;
  collapsedGroups: string[];
  onToggleCollapsed: (group: string) => void;
  onNavigate: (item: NavigationItem) => void;
  onSearch: () => void;
}

export const DesktopSidebar: React.FC<DesktopSidebarProps> = ({
  onToggleCollapse,
  permissions,
  isActive,
  collapsedGroups,
  onToggleCollapsed,
  onNavigate,
  onSearch,
}) => (
  <Box
    data-testid="nav-menu"
    sx={{
      width: SIDEBAR_WIDTH,
      height: '100vh',
      flexShrink: 0,
      position: 'relative',
      bgcolor: theme =>
        theme.palette.mode === 'dark'
          ? DARK_SHELL_SURFACE
          : LIGHT_SHELL_SURFACE,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    }}
  >
    <SidebarHeader onAction={onToggleCollapse} />
    <SidebarContent
      permissions={permissions}
      isActive={isActive}
      collapsedGroups={collapsedGroups}
      onToggleCollapsed={onToggleCollapsed}
      onNavigate={onNavigate}
      onSearch={onSearch}
    />
  </Box>
);
